module.exports = __webpack_public_path__ + "static/dashboard-03b79f4b5e265130e4a4cfa0bc91f688.png";